import React from 'react';

import Main from './Main';

const Search = () => {
    return (
        <div>
            <Main />
        </div>
    );
};

export default Search;



// WEBPACK FOOTER //
// ./src/pages/Search/Search.jsx